/* Elevana gummies PDP — generated by elevana-site-draft/build-gummies-shopify.py from the approved draft.
   Globals used by inline handlers: goMedia, pickSize, pickPlan, bumpQty, pickAdj. money() is gmMoney()
   because elevana-b4.js defines its own money(). */
/* ================= gallery ================= */
function goMedia(i){
  document.querySelectorAll('.gal-main .slide').forEach(function(s,n){s.classList.toggle('on',n===i)});
  document.querySelectorAll('.thumbs .thumb').forEach(function(t,n){t.classList.toggle('on',n===i)});
}

/* ================= main buy box ================= */
/* The count ladder is the only discount — no Buy 1/3/5 tier on top of it (see pre-rolls in DRAFT.md). */
var SUB_OFF=0;
var NAME=(window.EL_GM&&EL_GM.name)||'';
var sz={n:10,price:20.00}, plan='once', q=1;
function gmMoney(n){ return '$'+n.toFixed(2); }
function unitPrice(){ return plan==='sub' ? sz.price*(1-SUB_OFF) : sz.price; }
function render(){
  var total=unitPrice()*q;
  (function(e,t){if(e)e.textContent=t;})(document.getElementById('onceP'),gmMoney(sz.price));
  (function(e,t){if(e)e.textContent=t;})(document.getElementById('subP'),gmMoney(sz.price*(1-SUB_OFF)));
  document.getElementById('addBtn').innerHTML=window.EL_SOLDOUT?'Sold out':'Add to cart \u00b7 '+gmMoney(total);
  var sb=document.getElementById('sbBtn'); if(sb) sb.innerHTML=window.EL_SOLDOUT?'Sold out':'Add to cart \u00b7 '+gmMoney(total);
  var sm=document.getElementById('sbMeta');
  if(sm) sm.innerHTML='<b>'+NAME+'</b><span>'+sz.n+' gummies \u00b7 '+'Qty '+q+'</span>';
}
function pickSize(el){
  [].forEach.call(document.querySelectorAll('#sizes .sz'),function(b){b.classList.remove('on')});
  el.classList.add('on'); sz={n:+el.dataset.n, price:+el.dataset.price};
  goMedia(+el.dataset.slide);          /* 10 shows the pouch, 20/30 show the jar */
  render();
}
function pickPlan(p){
  plan=p;
  (document.getElementById('planOnce')||document.createElement('i')).classList.toggle('on', p==='once');
  (document.getElementById('planSub')||document.createElement('i')).classList.toggle('on',  p==='sub');
  render();
}
function bumpQty(d){ q=Math.max(1,Math.min(99,q+d)); document.getElementById('qty').textContent=q; render(); }

function cartAdd(n){ var c=document.querySelector('.cart-n'); if(c) c.textContent=(parseInt(c.textContent,10)||0)+n; }
function confirmBtn(btn,label,restore){
  if(btn.dataset.busy) return; btn.dataset.busy='1';
  btn.classList.add('added'); btn.innerHTML='\u2713 '+label;
  setTimeout(function(){ btn.classList.remove('added'); delete btn.dataset.busy; restore(); },1500);
}
document.getElementById('addBtn').addEventListener('click',function(e){
  e.preventDefault(); cartAdd(q); confirmBtn(this,'Added to cart',render);
});

/* sticky buy bar: appears once the main CTA scrolls out of view */
(function(){
  var bar=document.getElementById('stickyBuy'), cta=document.getElementById('addBtn');
  if(!bar||!cta) return;
  function sync(){ var bar=document.getElementById('stickyBuy'), cta=document.getElementById('addBtn'); if(!bar||!cta) return; var r=cta.getBoundingClientRect();  /* re-read: apps can re-render the buy box */ bar.classList.toggle('on', r.bottom < 0 || (window.innerWidth <= 760 && r.top > window.innerHeight)); }
  window.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync,{passive:true});
  window.addEventListener('load',sync); setTimeout(sync,1200);  /* images and fonts move the button after first paint */
  var sb=document.getElementById('sbBtn');
  if(sb) sb.addEventListener('click',function(e){ e.preventDefault(); cartAdd(q); confirmBtn(this,'Added',render); });
  sync();
})();

/* ================= bundle builder ================= */
var STRAINS=(window.EL_GM&&EL_GM.strains)||[];
STRAINS.forEach(function(s){ if(s.price_live) s.price=s.price_live; });
var TIERS=[{n:4,off:.20},{n:3,off:.15},{n:2,off:.10}];
var picked={};
function tierFor(n){ for(var i=0;i<TIERS.length;i++){ if(n>=TIERS[i].n) return TIERS[i]; } return {n:0,off:0}; }
function countItems(){ var t=0; for(var k in picked) t+=picked[k]; return t; }
function drawPicks(){
  document.getElementById('picks').innerHTML=STRAINS.map(function(s){
    var n=picked[s.id]||0;
    var right = n>0
      ? '<div class="qmini"><button onclick="pickAdj(\''+s.id+'\',-1)" aria-label="Remove one">\u2212</button><b>'+n+'</b><button onclick="pickAdj(\''+s.id+'\',1)" aria-label="Add one">+</button></div>'
      : '<button class="addbtn" onclick="pickAdj(\''+s.id+'\',1)">ADD +</button>';
    return '<div class="pick'+(n>0?' picked':'')+'">'+
      '<div class="ph"><img src="'+s.img+'" alt="'+s.name+'"></div>'+
      '<div class="meta"><h3>'+s.name+'</h3><p>'+s.note+'</p>'+
      '<div class="tags"><span class="badge '+s.cls+'">'+s.type+'</span>'+
      '<span class="badge" style="background:var(--bg-alt);color:var(--ink-soft)">'+s.size+' \u00b7 '+gmMoney(s.price)+'</span></div></div>'+
      right+'</div>';
  }).join('');
}
function pickAdj(id,d){
  picked[id]=Math.max(0,(picked[id]||0)+d);
  if(picked[id]===0) delete picked[id];
  drawPicks(); syncBundle();
}
function syncBundle(){
  var n=countItems(), t=tierFor(n), gross=0;
  STRAINS.forEach(function(s){ gross += (picked[s.id]||0)*s.price; });
  var net=gross*(1-t.off);
  document.querySelectorAll('#tiers .tierpill').forEach(function(p){ p.classList.toggle('hit', n>=+p.dataset.n); });
  var nextT=null;
  for(var i=TIERS.length-1;i>=0;i--){ if(n < TIERS[i].n){ nextT=TIERS[i]; break; } }
  var msg=document.getElementById('progMsg');
  if(nextT){ msg.innerHTML='Add <em>'+(nextT.n-n)+' more</em> to unlock '+Math.round(nextT.off*100)+'% off'; }
  else if(n>0){ msg.innerHTML='<em>20% off</em> unlocked \u2014 best price'; }
  else { msg.innerHTML='Add <em>2 packs</em> to unlock 10% off'; }
  document.getElementById('progFill').style.width=Math.min(100,(n/4)*100)+'%';
  document.getElementById('progCount').textContent=n+' selected';
  document.getElementById('bTotal').textContent=gmMoney(net);
  var was=document.getElementById('bWas'), sv=document.getElementById('bSave');
  if(t.off>0){ was.hidden=false; was.textContent=gmMoney(gross); sv.hidden=false; sv.textContent='You save '+gmMoney(gross-net)+' ('+Math.round(t.off*100)+'% off)'; }
  else { was.hidden=true; sv.hidden=true; }
  var b=document.getElementById('bundleBtn');
  if(!b.dataset.busy) b.innerHTML = n===0 ? 'Add stack to cart' : 'Add '+n+' to cart \u00b7 '+gmMoney(net);
}
document.getElementById('bundleBtn').addEventListener('click',function(e){
  e.preventDefault();
  var n=countItems(); if(n===0) return;
  var btn=this, items=[];
  STRAINS.forEach(function(s){ if(picked[s.id] && s.vid) items.push({id:s.vid, quantity:picked[s.id]}); });
  if(window.ElevanaCart && items.length){ window.ElevanaCart.add(items).catch(function(){}); }
  else { cartAdd(n); }
  confirmBtn(btn,n+' added',syncBundle);
  picked={}; drawPicks();
});

/* ================= marquee ================= */
var MQ=[['\ud83d\ude9a','Free Shipping over $79'],['\ud83c\uddfa\ud83c\uddf8','Nationwide Delivery'],
        ['\ud83e\udeaa','No Medical Card Required'],['\ud83d\udce6','Fast Discreet Shipping'],
        ['\ud83e\uddea','Lab Tested'],['\ud83c\udf6c','Candy-Shop Flavours'],['\u2705','21+ Verified']];
(function(){
  var row=MQ.map(function(m){ return '<span><i>'+m[0]+'</i>'+m[1]+'</span>'; }).join('');
  document.getElementById('mqIn').innerHTML=row+row;
})();

/* flavour pills keep the chosen count: product-gm-peach.html?n=20 opens on the 20-count */
function syncFlavLinks(){
  [].forEach.call(document.querySelectorAll('.flv'),function(a){
    a.href=a.getAttribute('href').split('?')[0]+(sz.n!==10?'?n='+sz.n:'');
  });
}
(function(){
  var n=(location.search.match(/[?&]n=(\d+)/)||[])[1];
  var el=n&&document.querySelector('#sizes .sz[data-n="'+n+'"]');
  if(el) pickSize(el);
})();
var _pickSize=pickSize; pickSize=function(el){ _pickSize(el); syncFlavLinks(); };
syncFlavLinks();

render(); drawPicks(); syncBundle();


/* phones: description clamps to 2 lines (elevana-fix.css); add a Read more toggle when it overflows */
(function(){
  var p=document.querySelector('.p-summary'); if(!p) return;
  var b=document.createElement('button'); b.type='button'; b.className='p-more'; b.textContent='Read more';
  p.insertAdjacentElement('afterend',b);
  function fit(){ if(p.classList.contains('open')) return; b.hidden = p.scrollHeight <= p.clientHeight+2; }
  b.addEventListener('click',function(){ var o=p.classList.toggle('open'); b.textContent=o?'Show less':'Read more'; b.hidden=false; });
  window.addEventListener('resize',fit,{passive:true}); fit();
})();
